import { css, injectGlobal } from '@emotion/css';
import Assert from 'Common/Assert';
import { SiteBasics } from 'Common/SiteBasics';
import { Theme } from 'Shared/backend/Theme';
import { standardRules } from 'Shared/common/Sanitise';
import { ConnectionToServer } from 'Shared/Root';
import { LoginBanner } from 'Shared/server/LoginBanner';
import { useServer, useSite } from 'Shared/SiteProvider';
import { inputStyle as authInputStyle, entryUrl } from 'Shared/users/AuthenticationForm';
import { createSignal, Match, Switch } from 'solid-js';

const style = () => css({
	background: 'white',
	minHeight: '100vh',

	'.vosLogo': {
		display: 'block',
		width: '5em',
		margin: '0 auto'
	}
});

const sectionStyle = () => css({
	maxWidth: 700,
	margin: '0 auto',
	padding: '2em'
});

const inputStyle = () => css(authInputStyle(),{
	width: '20em',
	marginTop: '1em'
});

const tickStyle = () => css({
	color: 'green',
	fontSize: '4em',
	margin: 0
});


//XXX coulde combine with LoginPage.tsx... but kind-of building another router at theat point?

export default function ForgotPasswordPage()
{
	const [sentEmail,setSentEmail] = createSignal();

	return (
		<div class={style()}>
			<LoginBanner />

			<section class={sectionStyle()}>
				<Switch>
					<Match when={!sentEmail()}>
						<GetAddress setSentEmail={setSentEmail} />
					</Match>
					<Match when={true}>
						<SentNotification sentEmail={sentEmail()} />
					</Match>
				</Switch>
			</section>
		</div>
	);
}

function GetAddress(P)
{
	injectGlobal([standardRules,{body:Theme.body}]);

	const server = useServer();
	const site = useSite();

	return (<>
		Forgot your account's password? 
		Enter your email address and we'll send you a recovery link.
		<br/>
		<input class={inputStyle()} type='text' name='email' autocomplete='off' required/>
		<br />
		<br />
		<button class={css(Theme.button)} onClick={() => requestEmail(server,site,P.setSentEmail)}>Request password change</button>
	</>);
}

function SentNotification(P:{sentEmail:string})
{
	return (<>
		<h2 class={tickStyle()}>&#10004</h2>

		<p>
			An account recovery email will have been sent to {P.sentEmail}, provided it exists
			within our system.
		</p>
		<p>
			If you don't see this email in your inbox within 15 minutes, 
			look for it in your junk mail folder. If you find it there, 
			please mark it as 'Not Junk'. 
		</p>
	</>);
}

async function requestEmail(server:ConnectionToServer,site:SiteBasics,setSentEmail)
{
	const returnTo = location.href.split('/').slice(0,3).join('/') + entryUrl(site.type);

	const email = Assert.htmlInputElement(document.querySelector('input[name=email]')).value.trim();
	if (email?.match(/.+@.+/) == null)
		return;
//TODO show an error in this case	

	try {
		await server.sendForgotPasswordEmail.mutate({email,returnTo});
		setSentEmail(email);
	}
	catch(err) {
console.log('ForgotPasswordGetAddressPage err:',err);		
	}
}

